import * as moment from 'moment';
import { Navigator } from './navigator.model';

export class LogError {
    constructor() {
        this.navigator = new Navigator();
    }

    public message: string = undefined;
    public date: moment.Moment = undefined;
    public navigator: Navigator = undefined;
    public stackTrace: any = undefined;
}
